import axios from 'axios'
import { Environment, getEnv } from './Enviroment';
import { AccessTokenData, APIResponse } from '../dataSchema/const';
import { DATA_SERVICE } from '../dataSchema/DataService';

export type Question = {
  id: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  formId: string;
  pageIndex: number;
  type: string;
  label: string;
  imageUrl: string;
  required: boolean;
  multipleChoice: boolean;
  customChoice: boolean;
  hasFollowUpQuestion: boolean;
  npsScore0_6: boolean;
  npsScore7_8: boolean;
  npsScore9_10: boolean;
  depend: boolean;
  questionDependId?: string;
  answerDepend?: string[];
  startText?: string;
  endText?: string;
  choices?: Array<{
    label: string;
    imageUrl: string;
    defaultAnswer: boolean;
  }>;
};

export type PageForm = {
  imageUrl: string;
  pageIndex: number;
  questions: Question[];
};

export type MobileForm = {
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  displayName: string;
  displayIntroduction: boolean;
  imageUrl: string;
  description: string;
  type: string;
  noOfSubmittedForm: number;
  status: string;
  userSegmentIds: string[];
  action: string;
  pageForms: PageForm[];
  giftPackages: {
    thanksContent: string;
    giftDetails: any[];
  };
};


export type FormDataType = {
  mobileForm?: MobileForm;
  credential?: {
    userId: string;
    mobile: string;
    leaderboardId: string;
  };
  popUp?: Record<string, any>;
}

export type FetchAuthDataResponse = {
  status: {
    code: number;
    appCode: number;
    success: boolean;
    message: string;
    detail: string;
  };
  data: FormData
} | null;



class APIService {
  _token: string | null = null;

  uid: string | null = null;

  private _env: Environment | null = null;

  private _accessTokenData: AccessTokenData | null = null;


  public constructor() {
    this._env = getEnv();
  }

  get environment(): Environment {
    return this._env;
  }

  set environment(value: Environment) {
    this._env = value;
  }


  getAPIEndPoint(): string {
    if (this._env) {
      // return 'https://api-v2.taptap.com.vn/taptap-webapp-proxy/v1/data-user/form/';
      return this._env.apiEndPoint;
    }

    return "";
  }

  get accessToken(): string | null {
    if (this._token) return this._token;
    if (this._accessTokenData) return this._accessTokenData.token;
    return null;
  }

  private __parseReponse(rs: any): APIResponse {
    let result = rs.data;
    if (rs.status === 200 && result) {
      if (result.status) {
        return result;
      }

      throw new Error("Invalid data format");
    }

    if (rs.status === 401) {
      return null;
    }
  }

  private __signInSuccessHandler(accessTokenData: AccessTokenData) {
    this._accessTokenData = accessTokenData;
    this._token = accessTokenData.token || accessTokenData.accessToken;
    this.uid = accessTokenData.id;
  }
  public parseTokenFromURL(): string {
    try {
      // Prefer explicit ?token= in query string
      const href = window.location.href || window.location.toString();
      const urlObj = new URL(href);
      const tokenFromQuery = urlObj.searchParams.get('token');
      if (tokenFromQuery && tokenFromQuery.length) {
        console.log('[API] parseTokenFromURL - token from query:', tokenFromQuery)
        return tokenFromQuery;
      }

      // Fallback: use the last pathname segment (without any query or hash)
      const pathname = urlObj.pathname || '';
      const segments = pathname.split('/').filter(Boolean);
      if (segments.length > 0) {
        const uid = segments[segments.length - 1];
        if (uid && !uid.includes('.')) {
          console.log('[API] parseTokenFromURL - token from pathname:', uid)
          return uid.trim();
        }
      }

      return null;
    } catch (e) {
      console.log('[API] parseTokenFromURL error', e);
      return null;
    }
  }

  __makeHeader(bearer: boolean = false) {
    if (bearer) {
      return {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this._token}`,
          "Access-Control-Allow-Origin": "*",
        },
      };
    }
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
    };
  }

  public getAuthUrl(): string {
    let token = this.parseTokenFromURL();
    if (token && token.length) {
      this._token = token;
      const url = `${this.getAPIEndPoint()}?token=${token}`
      return url;
    } else {
      return '';
    }
  }

  public submitSurveyUrl(): string {
    if (this._token && this._token.length) {
      const url = `${this.getAPIEndPoint()}/submit`
      return url;
    } else {
      return '';
    }
  }

  async getAPICall(endPoint: string) {
    try {
      if (this._token) {
        const result = await axios.get(endPoint, this.__makeHeader(true));
        if (result) {
          DATA_SERVICE.data = result.data.data;
          return result.data;
        }
      }
      return null
    } catch (error) {

      return null;
    }
  }

  async postAPICall(endPoint: string, params: any) {
    try {
      const result = await axios.post(endPoint, params, this.__makeHeader(true));
      if (result) {
        return result.data;
      }
      return null
    } catch (error) {

      return null;
    }
  }





  async fetchAuthData(): Promise<FetchAuthDataResponse> {
    let url = this.getAuthUrl();
    const res = await this.getAPICall(url);
    return res;
  }

  submitSurveyData(data: any) {
    let url = this.submitSurveyUrl();
    return this.postAPICall(url, data);
  }

}

export const API = new APIService();